import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import { UserProvider } from './context/UserContext';
import { useUser } from './context/UserContext';
import 'bootstrap/dist/css/bootstrap.min.css';

// Component Imports
import Login from './components/Login';
import NavBar from './components/NavBar';
import Footer from './components/Footer';

// Page Imports
import HomePage from './pages/HomePage';
import PostageAccountList from './pages/PostageAccountList'; //all postage accounts
import PaginatedPostageAccountList from './pages/PaginatedPostageAccountList';  // paginated accounts 
import PostageAccountSearch from './pages/PostageAccountSearch';
import CurrentPostageAccounts from './pages/CurrentPostageAccounts';
import PostageAccountDetails from './pages/PostageAccountDetails';
import PostageAccountEdit from './pages/PostageAccountEdit';
import PostageAccountCreate from './pages/PostageAccountCreate';
import WorktagChangeRequest from './pages/WorktagChangeRequest';
import UserList from './pages/UserList';
import PaginatedUserList from './pages/PaginatedUserList';
import UserDetails from './pages/UserDetails';
import UserEdit from './pages/UserEdit';
import Unauthorized from './pages/Unauthorized';

import NewUserForm from './components/NewUserForm';

// TEMPORARY FOR SEEDING
import PostageUsersUpload from './pages/PostageUsersUpload';
import PostageAccountsUpload from './pages/PostageAccountsUpload';

function App() {
// <Routes basename='/c2-pan'>
  return (
    <UserProvider>
      <Router>
        <div>
          <NavBar />

          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<HomePage />} />
            {/* This is ALL postage Accounts - probs not super useful with large dataset */}
            <Route path="/postage-account" element={<PostageAccountList />} />
            {/* This is the paginated postage accounts list */}
            <Route path="/postage-accounts/:pageNumber" element={<PaginatedPostageAccountList />} />
            {/* If no page number is given then redirect to the first page */}
            <Route path="/postage-accounts" element={<PaginatedPostageAccountList />} />
            <Route path="/search-postage-accounts" element={<PostageAccountSearch />} />
            <Route path="/postage-account/:postageAccountNumber" element={<PostageAccountDetails />} />
            <Route path="/postage-account/:postageAccountNumber/edit" element={<PostageAccountEdit />} />
            <Route path="/postage-account/:postageAccountNumber/WorktagChangeRequest" element={<WorktagChangeRequest />} />
            <Route path="/postage-account/user/:netId" element={<CurrentPostageAccounts />} />
            <Route path="/postage-account/new" element={<PostageAccountCreate />} />
            {/* This is ALL User Accounts - probs not super useful with large dataset */}
            <Route path="/user/" element={<UserList />} />
            {/* Paginated User Accounts */}
            <Route path="/users/:pageNumber" element={<PaginatedUserList />} />
            {/* If no page number is given then redirect to the first page */}
            <Route path="/users/" element={<PaginatedUserList />} />
            <Route path="/user/:netId" element={<UserDetails />} />
            <Route path="/user/:netId/edit" element={<UserEdit />} />
            <Route path="/unauthorized" element={<Unauthorized />} />

            <Route path="/NewUserForm" element={<NewUserForm />} />

            {/* For database seeding only - can remove for prod */}
            <Route path="/PostageUsersUpload" element={<PostageUsersUpload />} />
            <Route path="/PostageAccountsUpload" element={<PostageAccountsUpload />} />
          </Routes>

          <Footer />
        </div>
      </Router>
    </UserProvider>
  );
}

export default App;

